import { ClockHandler } from 'app/shared/time/clock_handler.service';
import { EntityType, TimelineDependentEntities } from 'app/agriculture/models/Entities';
import { toUnix } from 'app/shared/utilities/time';

export const MapBillboardWidth = 48;
export const MapBillboardHeight = 72;

export function getTimelineAppropriateUnix(
    entityType: EntityType | undefined,
    clockHandler: ClockHandler,
) {
    return entityType && TimelineDependentEntities.includes(entityType)
        ? clockHandler.getCursorTimeAsUnix()
        : toUnix(new Date());
}
